<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>{{!serviceId ? 'Add' : 'Update'}} Review Url</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="reviewUrlForm" style="width: 100%;">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Select Type</mat-label>
                <mat-select formControlName="type">
                  <mat-option value="Great">Great</mat-option>
                  <mat-option value="Good">Good</mat-option>
                  <!-- <mat-option value="Fair">Fair</mat-option>
                  <mat-option value="Poor">Poor</mat-option>
                  <mat-option value="Awful">Awful</mat-option> -->
                </mat-select>
                <mat-error *ngIf="
                    reviewUrlForm.controls['type'].touched &&
                    reviewUrlForm.controls['type'].hasError(
                      'required'
                    )
                  ">
                  This field is required.
                </mat-error>
              </mat-form-field>
           

            
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Percentage</mat-label>
                <input matInput placeholder="Percentage" formControlName="percentage" type="number">
                <mat-error
                  *ngIf="reviewUrlForm.controls['percentage'].touched && reviewUrlForm.controls['percentage'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
           
           
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Is Active</mat-label>
              <mat-select formControlName="isActive">
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
              <mat-error *ngIf="
                  reviewUrlForm.controls['isActive'].touched &&
                  reviewUrlForm.controls['isActive'].hasError(
                    'required'
                  )
                ">
                This field is required.
              </mat-error>
            </mat-form-field>
         
         
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Url</mat-label>
                <input matInput placeholder="Url" formControlName="url">
                <mat-error
                  *ngIf="reviewUrlForm.controls['url'].touched && reviewUrlForm.controls['url'].hasError('required')">
                  This is a required field.</mat-error>
                  <mat-error
                  *ngIf="reviewUrlForm.controls['url'].touched && reviewUrlForm.controls['url'].hasError('pattern')">
                  Please enter valid url.</mat-error>
              </mat-form-field>
         </div>

         <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
          <button mat-button type="button" class="sub-button" (click)="submit()">{{!serviceId ? 'Add' : 'Update'}}</button>
          <button class="can-button" (click)="this.location.back()" mat-button>Cancel</button>
        </div>
           
           
          </form>
    </div>
  </div>
  
